import { t } from 'ember-intl';
import {
  HdsCardContainer,
  HdsTextDisplay,
  HdsTextBody,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { boxPadding } from 'core/modifiers';

const Banner = <template>
  <HdsCardContainer
    @hasBorder="true"
    @level="mid"
    {{boxPadding "lg"}}
    data-test-scim-banner-container
  >
    <HdsTextDisplay
      @size="200"
      @tag="h4"
      {{boxPadding "0 0 xs"}}
      data-test-scim-banner-title
    >
      {{t "components.scim.banner.title"}}
    </HdsTextDisplay>
    <HdsTextBody
      @size="200"
      @tag="p"
      {{boxPadding "0 0 md 0"}}
      data-test-scim-banner-body
    >
      {{t "components.scim.banner.body"}}
    </HdsTextBody>
    <HdsLinkStandalone
      @icon="arrow-right"
      @iconPosition="trailing"
      @route="cloud.orgs.detail.settings.scim"
      @text={{t "components.scim.banner.action.enable"}}
      data-test-scim-banner-enable
    />
  </HdsCardContainer>
</template>;

export default Banner;
